<template>
  <div :class="[space]">
  </div>
</template>
<script>
export default {
  name: 'Space',
  props: {
    space: {
      type: String,
      default: 'vu-space-y-16x16'
    }
  }
}
</script>
<style>
.vu-space-y-20x20 {
  padding: 20px 0px 20px 0px;
}
.vu-space-y-16x16 {
  padding: 16px 0px 16px 0px;
}
.vu-space-y-12x12 {
  padding: 12px 0px 12px 0px;
}
.vu-space-y-8x8 {
  padding: 8px 0px 8px 0px;
}
.vu-space-y-4x4 {
  padding: 4px 0px 4px 0px;
}
</style>
